import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";

import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { MyDomain } from "../App";
export default function SignupPage() {
  const history = useHistory();

  const [height, width] = useWindowSize();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [height]);

  function useWindowSize() {
    const [size, setSize] = useState([window.innerHeight, window.innerWidth]);
    useEffect(() => {
      const handleResize = () => {
        setSize([window.innerHeight, window.innerWidth]);
      };
      window.addEventListener("resize", handleResize);
    }, []);
    return size;
  }
  const [FirstName, setFirstName] = useState("");
  const [LastName, setLastName] = useState("");
  const [Email, setEmail] = useState("");

  const [Role, setRole] = useState("");
  const [ChoosingRole, setChoosingRole] = useState(1);

  const [Password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSignup = async () => {
    const data = {
      FirstName: FirstName,
      LastName: LastName,
      Email: Email,
      Role: Role,
      Password: Password,
    };

    try {
      const response = await axios.post(`${MyDomain}Users/SignUp`, data);
      console.log(response.data);
      history.push("/");
    } catch (error) {
      console.error("Login error:", error.response?.data || error.message);
      alert("Invalid credentials. Please try again.");
    }
  };

  return (
    <div
      style={{
        flex: 1,
        background: " linear-gradient(to bottom,#fb7185, #ffff,#ffff)",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
      }}
    >
      {" "}
      <div style={{ display: "flex", flexDirection: "column", width: "40%" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            width: width < 768 ? "100%" : "80%",
          }}
        >
          <p>FirstName</p>
        </div>
        <TextField
          value={FirstName}
          onChange={(e) => setFirstName(e.target.value)}
          style={{
            width: width < 768 ? "100%" : "80%",
          }}
          id="outlined-basic"
          label="Enter first name"
          variant="outlined"
        />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            width: width < 768 ? "100%" : "80%",
          }}
        >
          <p>LastName</p>
        </div>
        <TextField
          value={LastName}
          onChange={(e) => setLastName(e.target.value)}
          style={{
            width: width < 768 ? "100%" : "80%",
          }}
          id="outlined-basic"
          label="Enter last name"
          variant="outlined"
        />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            width: width < 768 ? "100%" : "80%",
          }}
        >
          <p>Email</p>
        </div>
        <TextField
          value={Email}
          onChange={(e) => setEmail(e.target.value)}
          style={{
            width: width < 768 ? "100%" : "80%",
          }}
          id="outlined-basic"
          label="Enter your email"
          variant="outlined"
        />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            width: width < 768 ? "100%" : "80%",
          }}
        >
          <p>Password</p>
        </div>
        <FormControl
          style={{ width: width < 768 ? "100%" : "80%", borderRadius: 50 }}
          variant="outlined"
        >
          <InputLabel htmlFor="outlined-adornment-password">
            Enter your password
          </InputLabel>
          <OutlinedInput
            value={Password}
            onChange={(e) => setPassword(e.target.value)}
            id="outlined-adornment-password"
            type={showPassword ? "text" : "password"}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            label="Enter your password"
          />
        </FormControl>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: width < 768 ? "100%" : "80%",
            marginTop: 20,
          }}
        >
          <a>Are you teacher or Student ?</a>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: width < 768 ? "100%" : "80%",
            justifyContent: "space-around",
          }}
        >
          <button
            style={{
              marginTop: 20,
              backgroundColor: ChoosingRole === 1 ? "#27272a" : "gray",
              color: "#fff",
              border: "none",
              //padding: "10px 20px",
              cursor: "pointer",
              fontSize: "16px",
              width: "40%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: 50,
              borderRadius: 10,
            }}
            onClick={() => {
              setChoosingRole(1);
              setRole("Teacher");
            }}
          >
            Teacher
          </button>
          <button
            style={{
              marginTop: 20,
              backgroundColor: ChoosingRole === 2 ? "#27272a" : "gray",
              color: "#fff",
              border: "none",
              //padding: "10px 20px",
              cursor: "pointer",
              fontSize: "16px",
              width: "40%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: 50,
              borderRadius: 10,
            }}
            onClick={() => {
              setChoosingRole(2);
              setRole("Student");
            }}
          >
            Student
          </button>

          <button
            style={{
              marginTop: 20,
              backgroundColor: ChoosingRole === 2 ? "#27272a" : "gray",
              color: "#fff",
              border: "none",
              //padding: "10px 20px",
              cursor: "pointer",
              fontSize: "16px",
              width: "40%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: 50,
              borderRadius: 10,
            }}
            onClick={() => {
              setChoosingRole(3);
              setRole("Admin");
            }}
          >
            Admin
          </button>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: width < 768 ? "100%" : "80%",
          }}
        >
          <button
            style={{
              marginTop: 20,
              backgroundColor: "#27272a",
              color: "#fff",
              border: "none",
              //padding: "10px 20px",
              cursor: "pointer",
              fontSize: "16px",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: 50,
              borderRadius: 10,
            }}
            onClick={() => {
              handleSignup();
            }}
          >
            Sign up
          </button>
        </div>
      </div>
    </div>
  );
}
